<div [ngClass]="item.shop_status !== 'open' ? 'box full-width-card-closedShop' : 'box full-width-card'">
  <div class="image">
    <div class="icon-remove blue delete">
      <img id="img" class="thumbnailloading" src="{{item.image}}"
        (click)="item.dataList ? gotoStore(item) : gotoStore(item)"
        onerror=" this.onerror = null; this.src ='/assets/images/istockphoto1.svg'" />
      <div class="heart" (click)="favouriteShop(item.shop_id, item.isFavourite, item);">
        <ion-icon *ngIf="!item.isFavourite" name="heart-outline" class="heart-outline"></ion-icon>
        <ion-icon *ngIf="item.isFavourite" class="redicon" name="heart"></ion-icon>
      </div>
      <div class="rating">
        <ion-chip *ngIf="item.count > 0" class="view-rating">
          <ion-img alt="star" class="rating-image" src="/assets/images/ratingPage/akar-icons_star_yellow.svg"></ion-img>
          <ion-label class="rating-value">
            {{item.rating?.toFixed(1)}}({{item.count}})
          </ion-label>
        </ion-chip>
        <ion-chip *ngIf="item.count == 0" class="view-rating">
          <ion-img alt="star" class="rating-image" src="/assets/images/ratingPage/akar-icons_star.svg"></ion-img>
          <ion-label class="rating-value">
            {{item.rating?.toFixed(1)}}({{item.count}})
          </ion-label>
        </ion-chip>
      </div>
    </div>
  </div>
  <div class="content" (click)="gotoStore(item)">
    <div class="details">
      <ion-label class="title">
        {{item.shop_name | titlecase}}
      </ion-label>
      <span class="location">
        <ion-text>
          {{item.distance | number:'0.0-0'}} {{ 'Km' | language:'Km' }}
        </ion-text>•
        <ion-icon class="icon" name="location-outline"></ion-icon>
        {{ item?.locality }} {{ item?.city }}
      </span>
      <p *ngIf="item?.categories?.length" class="desc">
        <span class="value" *ngFor="let detail of item?.categories; let i = index">
          <span *ngIf="i>0">, </span>{{detail}}
        </span>
      </p>
      <p *ngIf="!item?.categories?.length" class="desc custom-paragraph">
        {{'catalognotavailable' |language:'Catalog not available'}}</p>
      <div class="delivering-status">
        <a (click)="openWithInWebBrowser(item); direction($event)">
          <img class="title-image" src="/assets/direction-icon.svg" />
        </a>
        <a (click)="direction($event)" [href]="'tel:'+item.seller.phone">
          <img class="title-image" src="/assets/Call-homeIcon.svg" />
        </a>
      </div>
    </div>
  </div>
</div>